import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import BasicInfoStepController from 'store/pages/initiate-quote/altus/step-controllers/basicInfoStepController';
import {
  TabIMFormStyled,
  IMZipCodeFieldStyled,
  IMZipStateFieldStyled,
  IMZipCountyFieldStyled,
} from 'components/common/initiate-proposal/styles';
import { ALTUS_INITIATE_QUOTE_BASIC_INFO_FORM_ID } from '../constants';

interface Props {
  basicInfoStepController: BasicInfoStepController;
}

const AltusBasicInfoStep: React.FC<Props> = observer(({ basicInfoStepController }) => {
  const { form, effectiveDatesOptions } = basicInfoStepController;

  return (
    <TabIMFormStyled id={ALTUS_INITIATE_QUOTE_BASIC_INFO_FORM_ID} formController={form}>
      <SectionTitle
        title="Basic Information"
        subtitle="Complete the required information before choosing a proposal experience"
      />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />
    </TabIMFormStyled>
  );
});

export default AltusBasicInfoStep;
